<template>
  <div class="progression">
    <div class="progression-card">
      <h4>Checkliste</h4>
      <ul>
        <li v-for="(step, name, i) in steps" v-bind:key="i">
          <div class="row">
            <div class="col-10 progress-label">
              <span class="list-count">{{ i + 1 }}. </span>{{ step.name }}
            </div>
            <div class="col-2 checkbox-wrapper">
              <div
                :class="{ checked: step.checked == true }"
                class="checkbox"
              ></div>
            </div>
          </div>
        </li>
      </ul>

      <div class="progression-footer">
        <p v-html="contactInfo"></p>
      </div>
    </div>
  </div>
</template>
<script>
//import EventBus from '../event-bus.js';
export default {
  data() {
    return {};
  },

  computed: {
    steps: function () {
      let steps = {};
      let self = this;

      this.$store.state.pages.forEach(function (page) {
        let status = self.isPageFinished(page);

        if (
          steps[page.progress_group] === undefined ||
          (steps[page.progress_group] !== undefined && status === false)
        ) {
          steps[page.progress_group] = {
            name: page.progress_group,
            checked: status,
          };
        }
      });

      steps["anfragen"] = {
        name: "Anfragen",
        checked: this.$store.state.submitted,
      };

      return steps;
    },

    contactInfo: function () {
      return this.$store.state.surveyJSON.dbCustomData.contactInfo;
    },
  },

  methods: {
    isPageFinished: function (page) {
      let allQuestionsAnswered = true;

      page.questions.some(function (question) {
        if (
          question.hasInput === true &&
          question.visible === true &&
          question.isAnswered !== true
        ) {
          allQuestionsAnswered = false;
        }
      });

      return allQuestionsAnswered;
    },
  },
};
</script>

<style scoped>
/*
@font-face {
  font-family: "vipernora";
  src: url(../assets/VIPER___.TTF) format("truetype");
}

.progression-wrapper {
  position: relative;
}

h4 {
  font-family: deinebaustoffesecondary;
  color: #000;
  font-size: 1.4rem;
  text-transform: uppercase;
  padding-left: 20px;
}

ul {
  margin-top: 18px;
  margin-bottom: 20px;
  list-style: none;
  padding-left: 35px;
}

ul li {
  margin-top: 4px;
  font-family: deinebaustoffesecondary;
  text-transform: uppercase;
  font-size: 1rem;
  color: #000;
}

ul li div {
  padding: 0;
}

.progression-card {
  min-width: 200px;
  min-height: 320px;
  margin: auto auto;
  padding: 20px 40px 0 15px;
  position: absolute;
  z-index: 10;
  top: 80px;
  left: -45px;

  font-family: deinebaustoffesecondary;

  transform: rotate(-5deg);
  background-image: url(../assets/zettel_bg.png);
  background-size: 100% auto;
  background-repeat: no-repeat;
}



.progression-card .checkbox {
  border: 4px solid #000;
  width: 22px;
  height: 25px;
  float: right;
}

.progression-card .checkbox.checked:after {
  content: " ";
  width: 27px;
  height: 35px;
  background-image: url("../assets/check.png");
  background-repeat: no-repeat;
  background-size: 100% auto;

  position: absolute;
  top: -12px;
  left: 15px;
  display: table;
}

.progression-card .checkbox-wrapper {
  clear: both;
}

.progression-footer p {
  font-size: 0.8rem;
  margin: 0;
  color: #000;
  padding-left: 20px;
}

@media(min-width: 1200px) {
  h4 {
    font-family: deinebaustoffesecondary;
    color: #000;
    font-size: 1.7rem;
    text-transform: uppercase;
    padding-left: 20px;
  }
  .progression-card {
    min-width: 240px;
    min-height: 320px;
    margin: auto auto;
    padding: 20px 40px 0 15px;
    position: absolute;
    z-index: 10;
    top: 80px;
    left: -45px;

    font-family: deinebaustoffesecondary;

    transform: rotate(-5deg);
    background-image: url(../assets/zettel_bg.png);
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  ul li {
    margin-top: 4px;
    font-family: deinebaustoffesecondary;
    text-transform: uppercase;
    font-size: 1.1rem;
    color: #000;
  }
}*/
</style>
